import React     from 'react';
import TableItem from "./TableItem"
import "./Timetables.css";

const Timetables = () => {
    
    
    

    const column1 = [
        {time: "09:00 - 09:10", text: <p className = "tableItemText">Açılış, Hackathon Tanıtımı                                             <br/><span>Moderatör</span></p>},
        {time: "09:10 - 09:30", text: <p className = "tableItemText">Sovos ve Çalışma Ortamı                                                <br/><span>Canalp Büyükuysal, Human Resource Manager</span></p>},
        {time: "09:30 - 10:00", text: <p className = "tableItemText">Bir Developer'ın Günlük Hayatı                                         <br/><span>Yunus Taştutan, Director Product Development</span></p>},
        {time: "10:00 - 10:10", text: <p className = "tableItemText">Ara</p>},
        {time: "10:10 - 10:30", text: <p className = "tableItemText">e-Fatura ve e-Fatura Onayı Nedir, Nasıl Yapılır, Paydaşları Kimlerdir? <br/><span>Ayhan Boyacıoğlu, VP Product Management</span></p>},
        {time: "10:30 - 11:00", text: <p className = "tableItemText">Dijitalizasyonun Geleceği                                              <br/><span>Christiaan Van der Valk, VP Strategy & Regulatory</span></p>},
        {time: "11:00 - 11:30", text: <p className = "tableItemText">Yapay Zeka ve Büyük Veriye Giriş                                       <br/><span>Didem Gündoğdu, R&D Technical Manager</span></p>},
        {time: "11:30 - 12:00", text: <p className = "tableItemText">• Web 3.0 Nedir? Avantajları Nelerdir? <br/>
                                                                     • Web 3.0 ve Blockchain Entegrasyonu   <br/>
                                                                     • Blockchain Dünyasında İş Olanakları  <br/>
                                                                     <span>Hakkı Alkan, Owner - ShiftDelete.net</span></p>},
        {time: "12:00 - 13:00", text: <p className = "tableItemText">ÖĞLE ARASI</p>}
    ]

    const column2Row1 = [
        {time: "13:00 - 15:00", text: <p className = "tableItemText">• Hyperledger Fabric ile Blockchain Çözümleri <br/>
                                                                     • Blockchain Ağı Kurulumu                     <br/>
                                                                     • Akıllı Sözleşme Kodlama                     <br/>
                                                                     • İş Kurallarının Koda Aktarılması            <br/>
                                                                     <span>Ümmügülsüm Özalp, Blockchain Projects Lead - ATEZ</span></p>},
        {time: "15:00 - 15:20",   text: <p className = "tableItemText">Ara                      </p>},
        {time: "15:20 - 15:30",   text: <p className = "tableItemText">Hackathon Bilgilendirmesi</p>},
        {time: "15:30 - 24 saat", text: <p className = "tableItemText">Yarışma Başlangıcı       </p>}
    ] 

    const column2Row2 = [
        {time: "24 saat - 15:30", text: <p className = "tableItemText">Yarışma Bitişi           </p>},
        {time: "15:30 - 16:00",   text: <p className = "tableItemText">Ara                      </p>},
        {time: "16:00 - 18:00",   text: <p className = "tableItemText">Proje Sunumları          </p>},
        {time: "18:00 - 20:00",   text: <p className = "tableItemText">Değerlendirme Süreci     </p>},
        {time: "20:00",           text: <p className = "tableItemText">Kazananların Açıklanması </p>}
    ] 

    return (
        <div className = "timeTables">
            <h2>Etkinlik Takvimi</h2>

            <div className = "program">
                <div className = "programColumn">
                    <h3 id = "programFirstH3">Bootcamp ve Hackathon Başlangıcı</h3>
                    {column1.map((item)=>{
                        return <TableItem key = {item.time} time = {item.time} text= {item.text}/>
                    })}
                </div>
                <div className = "programColumn">
                    {column2Row1.map((item)=>{
                        return <TableItem key = {item.time} time = {item.time} text= {item.text}/>
                    })}
                    <h3 id = "programSecondH3">Hackathon Bitişi ve Proje Sunumları</h3>
                    {column2Row2.map((item)=>{
                        return <TableItem key = {item.time} time = {item.time} text= {item.text}/>
                    })}
                </div>
            </div>
        </div>
    )
}

export default Timetables;